'use client'

import ViewIntersection from '@app/components/analytics/view-intersection/view-intersection'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {ReactNode} from 'react'

type Props = {
  children: ReactNode
  layout: string
  className?: string
}

const FaqSectionVisiblityWrapper = ({children, layout, className}: Props) => {
  return (
    <ViewIntersection onVisible={triggerAnalytics('layout-shown', {layout}).sendAll} className={className}>
      {children}
    </ViewIntersection>
  )
}

export default FaqSectionVisiblityWrapper
